import { isGeneratedFile } from './is-generated-file.util';
import { stripFrontmatter } from './strip-frontmatter.util';
import { stripManagedChrome } from './strip-managed-chrome.util';

/**
 * The markdown the domain-file viewer renders: the leading frontmatter block stripped, then a Generated file's managed
 * chrome. `file://` references are kept.
 *
 * @param name The file's name, which decides whether it is a Generated file.
 * @param content The file's stored content, frontmatter included.
 * @returns The rendered markdown.
 */
export function toClarityReaderMarkdown(name: string, content: string): string {
	const body = stripFrontmatter(content);

	return isGeneratedFile(name, content) ? stripManagedChrome(body) : body;
}
